import { createFeatureSelector, createSelector } from '@ngrx/store';
import { commonIdBookmarkAndAnsweredPaperFeatureKey, State } from '../../reducers/common-id/common-id-bookmark-and-answered-paper.reducer';

const selectCommonIdBookmarkAndAnsweredPaperState = createFeatureSelector<State>(commonIdBookmarkAndAnsweredPaperFeatureKey);

export const getFindCommonIdBookmarkAndAnsweredPaperResult = createSelector(
  selectCommonIdBookmarkAndAnsweredPaperState,
  state => state.findBookmarkAndAnsweredPapersResult
);
